import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgSlidersIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M25.333 10.667a4 4 0 1 0 0 8 4 4 0 0 0 0-8M18.8 13.333a6.669 6.669 0 0 1 13.066 0h26.8V16h-26.8A6.669 6.669 0 0 1 18.8 16H5.333v-2.667zM41.333 28a4 4 0 1 0 0 8 4 4 0 0 0 0-8M34.8 30.667a6.669 6.669 0 0 1 13.066 0h10.8v2.666h-10.8a6.669 6.669 0 0 1-13.066 0H5.333v-2.666zm-9.467 14.666a4 4 0 1 0 0 8 4 4 0 0 0 0-8M18.8 48a6.669 6.669 0 0 1 13.066 0h26.8v2.667h-26.8a6.669 6.669 0 0 1-13.066 0H5.333V48z"
    />
  </svg>
)
export default SvgSlidersIcon
